export class TrendData{
    public OrgNodeId:string;
    public FiscalYearId:number;

    //Membership 
    public MembersJuly1:number;
    public MembersActual:number;
    public MembersGoal:number;

    //Gender
    public MembersGenderFemale:number;
    public MembersGenderMale:number;
    public MembersGenderUnreported:number;

    //Age 
    public MembersAge29Under:number;
    public MembersAge3039:number;
    public MembersAge4049:number;
    public MembersAge5059:number;
    public MembersAge6069:number;
    public MembersAge70Over:number;
    public MembersAgeUnreported:number;

    //Annual Fund
    public AnnualFundGoal:number;
    public AnnualFundActual:number;

    //Project Funding
    public ServiceCash:number;
    public ServiceInKind:number;

    //Volunteers
    public ServiceVolunteers:number;
    public ServiceVolunteerHours:number;

    constructor( orgNodeId:string, fiscalYearId:number, membersJuly1:number, membersActual:number, membersGoal:number, membersGenderFemale:number, membersGenderMale:number, membersGenderUnreported:number,
                membersAge29Under:number, membersAge3039:number, membersAge4049:number, membersAge5059:number, membersAge6069:number, membersAge70Over:number, membersAgeUnreported:number,
                annualFundGoal:number, annualFundActual:number, serviceCash:number, serviceInKind:number, serviceVolunteers:number, serviceVolunteerHours:number){

        this.OrgNodeId = orgNodeId;
        this.FiscalYearId = fiscalYearId;
        this.MembersJuly1 = membersJuly1;
        this.MembersActual = membersActual;
        this.MembersGoal = membersGoal;
        this.MembersGenderFemale = membersGenderFemale;
        this.MembersGenderMale = membersGenderMale;
        this.MembersGenderUnreported = membersGenderUnreported;
        this.MembersAge29Under = membersAge29Under;
        this.MembersAge3039 = membersAge3039;
        this.MembersAge4049 = membersAge4049;
        this.MembersAge5059 = membersAge5059;
        this.MembersAge6069 = membersAge6069;
        this.MembersAge70Over = membersAge70Over;
        this.MembersAgeUnreported = membersAgeUnreported;
        this.AnnualFundGoal = annualFundGoal;
        this.AnnualFundActual = annualFundActual;
        this.ServiceCash = serviceCash;
        this.ServiceInKind = serviceInKind;
        this.ServiceVolunteers = serviceVolunteers;
        this.ServiceVolunteerHours = serviceVolunteerHours;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/trend-data.ts